<div class="card-main decrease" *transloco="let t; prefix: 'fuelDashboard'">
	<div class="card-body card-barline-box" *ngIf="!isLoading; else noDataTitle">
		<div class="graph-up d-flex align-items-center justify-content-between" *ngIf="hasData(); else noDataTitle">
			<div class="graph-text">
				<h4>{{ t('widgets.totalDecrease') }}</h4>
				<app-graph-trend-icon [percentageChange]="percentageDifference" [formattedChange]="formatPercentChange()"
					[formatValue]="formatValue(value)" [isUptrendPositive]="isUptrendPositive()">
				</app-graph-trend-icon>
			</div>
			<div class="button-wrapper">
				<button *ngIf="widgetExpandable" (click)="fullChartClick()" class="graph-btn">
					<img src="assets/images-fuel/grapBtnIcon.svg" alt="graph-icon" />
				</button>
			</div>
		</div>
		<div style="height: 100%;">
			@defer (on timer(100ms)) {
			@if (hasData()) {
			<app-grouped-bar-chart [data]="totalDecreaseData"
				[subgroups]="[{name:'Driving', legend: t('charts.drivingConsumption'), color: '#FF7F00'}, {name:'Unusual', legend: t('charts.unusualDecrease'), color: '#3873C9'}]"
				[labelKey]="'label'" [margin]="{ top: 30, right: 10, bottom: 40, left: 0 }" [viewMode]="viewMode"
				[yTicks]="yTicks" [barWidth]="12" [chartHeight]="175" [exportBtn]="false" [tooltipUnit]="getTooltipUnit()" />
			} @else {
			<div class="d-flex align-items-center justify-content-center no-data">
				  <app-empty-state></app-empty-state>
			</div>
			}
			}
		</div>
	</div>
	<ng-template #noDataTitle>
		<div class="graph-text">
			<h4>{{ t('widgets.totalDecrease') }}</h4>
		</div>
	</ng-template>
	<div>
		<div class="card-loader" *ngIf="isLoading">
			<div class="spinner-border text-primary" role="status">
				<span class="visually-hidden">{{ t('widgets.loadingTotalDecrease') }}</span>
			</div>
		</div>
	</div>
</div>